import { RaRecord } from 'react-admin';

export const transformWorkerDetails = (record: RaRecord) => {
  return {
    ...record,
    drivers_license_state: record?.drivers_license_state ? `US-${record?.drivers_license_state}` : null,
  };
};
